<script setup>
import {ref, computed, watch} from 'vue'
import {useRoute} from 'vue-router'
import {useFormStore} from '@/stores/form'
import {useComponentsStore} from '@/stores/components'
import {useUserStore} from '@/stores/user'
import FormSidebarBtn from "./FormSidebarBtn.vue"
import api from '@/services/api'

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
    alwaysShow: Boolean
})

const route = useRoute()

const formStore = useFormStore(props.formId)
const componentsStore = useComponentsStore()
const userStore = useUserStore()

const hasVariations = ref(false)

const isArchived = computed(() => formStore.currentData?.isArchived)
const productTypeId = computed(() => formStore.currentData?.productTypeId)
const tableName = computed(() => formStore.tableName)
const id = computed(() => formStore.id)
const singularLabel = computed(() => formStore.singularLabel)
const componentId = computed(() => componentsStore.componentIds[tableName.value])
const component = computed(() => componentsStore.items.find(obj => obj.id === componentId.value))
const hasAccess = computed(() => userStore.access(tableName.value, 'delete'))

const show = computed(() => {
    // Allows individual uses of the button to always be shown, such as the Website Editor's content sidebar
    if (props.alwaysShow) {
        return true
    }

    return (
        id.value &&
        component.value?.deleteOption &&
        (isArchived.value || !component.value?.useArchive) &&
        tableName.value !== 'product_options' &&
        !hasVariations.value &&
        hasAccess.value
    )
})

// --- Watchers ---

watch(productTypeId, async (value) => {
    if (tableName.value === 'product_options' && value) {
        const obj = await api.post('api/ProductTypes/hasVariations', {
            typeId: value,
        })
        hasVariations.value = obj.data.count > 0
    } else {
        hasVariations.value = false
    }
}, {immediate: true})

// --- Methods ---

const onClick = () => {
    formStore.delete({
        siteTree: route.name === 'siteTree'
    })
}
</script>

<template>
    <FormSidebarBtn v-if="show" @click.prevent="onClick" class="text-danger">
        <i class="me-2 bi bi-trash"/>
        Delete {{ singularLabel }}
    </FormSidebarBtn>
</template>